import React from 'react';
import { Box, VStack, Text, Button, HStack } from '@chakra-ui/react';
import { ScannedQRData } from '@/types/payment';

interface PaymentSuccessContentProps {
  qrData: ScannedQRData;
  amount: number;
  transactionId: string | null;
  onClose: () => void;
}

export const PaymentSuccessContent: React.FC<PaymentSuccessContentProps> = ({
  qrData,
  amount,
  transactionId = '',
  onClose,
}) => {
  return (
    <VStack gap={6} w="full" p={4} userSelect="none">
      {/* 成功アイコン */}
      <Box
        w="80px"
        h="80px"
        borderRadius="full"
        bg="teal.500"
        display="flex"
        alignItems="center"
        justifyContent="center"
        animation="scaleIn 0.3s ease-out"
      >
        <Text fontSize="4xl" color="white">
          ✓
        </Text>
      </Box>

      {/* 成功メッセージ */}
      <VStack gap={2}>
        <Text fontSize="2xl" fontWeight="bold" color="gray.800">
          支払いが完了しました
        </Text>
        <Text fontSize="sm" color="gray.600" textAlign="center">
          お支払いありがとうございます
        </Text>
      </VStack>

      {/* 支払金額 */}
      <Box w="full" bg="teal.50" borderRadius="lg" p={6}>
        <Text fontSize="sm" color="gray.600" mb={2} textAlign="center">
          お支払い金額
        </Text>
        <Text fontSize="4xl" fontWeight="bold" color="teal.600" textAlign="center">
          ฿{amount.toLocaleString()}
        </Text>
      </Box>

      {/* 取引詳細 */}
      <Box w="full" bg="gray.50" borderRadius="lg" p={4}>
        <VStack gap={3} align="stretch">
          <HStack justify="space-between">
            <Text fontSize="sm" color="gray.600">
              支払先
            </Text>
            <Text fontSize="sm" fontWeight="semibold" color="gray.800">
              {qrData.merchantName}
            </Text>
          </HStack>
          <HStack justify="space-between">
            <Text fontSize="sm" color="gray.600">
              取引ID
            </Text>
            <Text fontSize="xs" fontFamily="monospace" color="gray.800">
              {transactionId}
            </Text>
          </HStack>
          <HStack justify="space-between">
            <Text fontSize="sm" color="gray.600">
              日時
            </Text>
            <Text fontSize="sm" color="gray.800">
              {new Date().toLocaleString('ja-JP', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </Text>
          </HStack>
        </VStack>
      </Box>

      {/* アクションボタン */}
      <VStack gap={2} w="full" mt={4}>
        <Button w="full" size="lg" colorPalette="teal" onClick={onClose}>
          完了
        </Button>
        {/* 将来的な拡張用 */}
        {/* <Button w="full" size="lg" variant="outline" colorPalette="teal">
          領収書を表示
        </Button> */}
      </VStack>

      {/* 注意事項 */}
      <Box w="full" bg="blue.50" borderRadius="lg" p={3}>
        <HStack gap={2}>
          <Text fontSize="lg">ℹ️</Text>
          <Text fontSize="xs" color="gray.700">
            取引履歴はホーム画面から確認できます
          </Text>
        </HStack>
      </Box>
    </VStack>
  );
};
